// import React, { useEffect, useState } from "react";
// import { onAuthStateChanged } from "firebase/auth";
// import { ref, get } from "firebase/database";
// import { auth, database as realtimeDb } from "../FirebaseConfig";
// import { useLocation, useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";
// import { FaChevronDown, FaChevronUp, FaBox, FaReceipt, FaTruck, FaClock } from "react-icons/fa";

// export default function OrdersPage() {
//   const [user, setUser] = useState(null);
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [animationData, setAnimationData] = useState(null);
//   const [expandedOrders, setExpandedOrders] = useState({});
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetch("/assets/General/orderLoading.json")
//       .then((res) => res.json())
//       .then((data) => setAnimationData(data))
//       .catch((err) => console.error("Error loading animation:", err));
//   }, []);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);
//         fetchUserOrders(currentUser.uid);
//       } else {
//         const path = new URLSearchParams(location.search).get("redirect") || "/orders";
//         navigate(`/login?redirect=${path}`);
//       }
//     });
//     return () => unsubscribe();
//   }, [navigate, location.search]);

//   const fetchUserOrders = async (uid) => {
//     setLoading(true);
//     try {
//       const snapshot = await get(ref(realtimeDb, "orders"));
//       if (snapshot.exists()) {
//         const userOrders = Object.entries(snapshot.val())
//           .filter(([_, order]) => order.userId === uid && order.paymentStatus !== "Failed")
//           .map(([orderId, order]) => ({ orderId, ...order }))
//           .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
//         setOrders(userOrders);
//       }
//     } catch (err) {
//       console.error("Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleExpand = (orderId) => {
//     setExpandedOrders(prev => ({ ...prev, [orderId]: !prev[orderId] }));
//   };

//   const getStatusStyle = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'delivered': return 'bg-green-100 text-green-700 border-green-200';
//       case 'shipped': return 'bg-blue-100 text-blue-700 border-blue-200';
//       case 'pending': return 'bg-orange-100 text-orange-700 border-orange-200';
//       default: return 'bg-gray-100 text-gray-700 border-gray-200';
//     }
//   };

//   if (loading) return (
//     <div className="h-screen flex flex-col justify-center items-center bg-gray-50">
//       <div className="w-64 md:w-80"><Lottie animationData={animationData} loop /></div>
//       <p className="text-gray-500 font-medium animate-pulse">Loading your purchase history...</p>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-50 pt-28 pb-12 px-4">
//       <div className="max-w-5xl mx-auto">
        
//         {/* Header Section */}
//         <div className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4">
//           <div>
//             <h1 className="text-3xl font-black text-gray-900 tracking-tight">My Orders</h1>
//             <p className="text-gray-500 mt-1">Track and manage your recent purchases</p>
//           </div>
//           <div className="bg-white px-4 py-2 rounded-2xl shadow-sm border border-gray-100 flex items-center gap-2">
//             <FaReceipt className="text-orange-500" />
//             <span className="text-sm font-bold text-gray-700">{orders.length} Total Orders</span>
//           </div>
//         </div>

//         {orders.length > 0 ? (
//           <div className="space-y-6">
//             {orders.map((order) => {
//               const timeDiff = (new Date().getTime() - order.createdAt) / (1000 * 60);
//               const isExpanded = expandedOrders[order.orderId];

//               return (
//                 <div key={order.orderId} className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300">
                  
//                   {/* Card Header: Quick Info Bar */}
//                   <div className="bg-gray-50/50 p-4 md:px-8 border-b border-gray-100 grid grid-cols-2 md:grid-cols-4 gap-4">
//                     <div>
//                       <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Order Placed</p>
//                       <p className="text-sm font-bold text-gray-800">
//                         {order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : "N/A"}
//                       </p>
//                     </div>
//                     <div>
//                       <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Total Amount</p>
//                       <p className="text-sm font-black text-gray-900 font-mono">₹{order.totalAmount}</p>
//                     </div>
//                     <div className="hidden md:block">
//                       <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400">Ship To</p>
//                       <p className="text-sm font-bold text-gray-800 line-clamp-1">{order.address?.customerName || user?.displayName || "User"}</p>
//                     </div>
//                     <div className="text-right">
//                       <p className="text-[10px] uppercase tracking-wider font-bold text-gray-400 mb-1">Status</p>
//                       <span className={`text-[10px] px-2 py-1 rounded-full font-black uppercase border ${getStatusStyle(order.orderStatus)}`}>
//                         {order.orderStatus}
//                       </span>
//                     </div>
//                   </div>

//                   {/* Card Body */}
//                   <div className="p-6 md:p-8">
//                     <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
//                       <div className="flex items-center gap-4">
//                         <div className="bg-orange-50 p-4 rounded-2xl text-orange-600">
//                           <FaBox size={24} />
//                         </div>
//                         <div>
//                           <p className="text-xs text-gray-400 font-bold">ORDER ID</p>
//                           <h2 className="text-lg font-black text-gray-800 tracking-tight">#{order.orderId}</h2>
//                         </div>
//                       </div>

//                       <div className="flex flex-col sm:flex-row gap-3">
//                         {order.paymentStatus === "Pending" ? (
//                           <div className="flex items-center gap-3 bg-amber-50 p-3 rounded-2xl border border-amber-100">
//                             <FaClock className="text-amber-600 animate-spin-slow" />
//                             <div>
//                               <p className="text-xs font-bold text-amber-800 leading-none">Processing Payment</p>
//                               {timeDiff > 25 && (
//                                 <button 
//                                   onClick={() => navigate(`/payment-stat?id=${order.orderId}&mId=${order.paymentId}`)}
//                                   className="text-[10px] text-amber-600 underline font-black uppercase mt-1"
//                                 >
//                                   Re-check Status
//                                 </button>
//                               )}
//                             </div>
//                           </div>
//                         ) : (
//                           <button
//                             onClick={() => navigate(`/order?id=${order.orderId}`)}
//                             className="bg-gray-900 text-white px-8 py-3 rounded-2xl font-bold text-sm hover:bg-orange-600 transition-all flex items-center justify-center gap-2 shadow-lg shadow-gray-200"
//                           >
//                             <FaTruck /> Track Shipment
//                           </button>
//                         )}
//                       </div>
//                     </div>

//                     {/* Collapsible Products Section */}
//                     <div className="mt-8">
//                       <button
//                         onClick={() => toggleExpand(order.orderId)}
//                         className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-100 hover:bg-gray-100 transition-colors"
//                       >
//                         <div className="flex items-center gap-3">
//                           <span className="bg-white w-8 h-8 rounded-full flex items-center justify-center text-xs font-black shadow-sm border border-gray-100">
//                             {order.products.length}
//                           </span>
//                           <span className="text-sm font-bold text-gray-700 uppercase tracking-wide">View Items</span>
//                         </div>
//                         {isExpanded ? <FaChevronUp className="text-gray-400" /> : <FaChevronDown className="text-gray-400" />}
//                       </button>

//                       {isExpanded && (
//                         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 animate-in slide-in-from-top-2 duration-300">
//                           {order.products.map((product, index) => {
//                             const savings = (product.price - product.actualPrice) * product.quantity;
//                             return (
//                               <div key={index} className="flex gap-4 p-3 bg-white rounded-2xl border border-gray-100 shadow-sm relative overflow-hidden">
//                                 {savings > 0 && (
//                                   <div className="absolute top-0 right-0 bg-green-500 text-white text-[8px] font-black px-2 py-0.5 rounded-bl-lg uppercase">
//                                     Saved ₹{savings}
//                                   </div>
//                                 )}
//                                 <img src={product.thumbnail} alt={product.name} className="w-16 h-16 object-cover rounded-xl shadow-inner border border-gray-50" />
//                                 <div className="flex-1 flex flex-col justify-center">
//                                   <p className="text-xs font-black text-gray-800 line-clamp-1">{product.name}</p>
//                                   <p className="text-[10px] text-gray-400 font-bold uppercase">Qty: {product.quantity}</p>
//                                   <div className="flex items-center gap-2 mt-1">
//                                     <span className="text-sm font-black text-gray-900">₹{product.actualPrice}</span>
//                                     {product.price > product.actualPrice && (
//                                       <span className="text-[10px] text-gray-400 line-through font-bold">₹{product.price}</span>
//                                     )}
//                                   </div>
//                                 </div>
//                               </div>
//                             );
//                           })}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="bg-white rounded-[3rem] p-12 text-center shadow-sm border border-gray-100 flex flex-col items-center">
//             <div className="bg-orange-50 w-24 h-24 rounded-full flex items-center justify-center mb-6">
//               <FaBox className="text-orange-500 text-4xl" />
//             </div>
//             <h2 className="text-2xl font-black text-gray-900">No orders yet</h2>
//             <p className="text-gray-500 mt-2 max-w-xs mx-auto">Looks like you haven't discovered our collection yet. Let's change that!</p>
//             <button 
//               onClick={() => navigate('/')}
//               className="mt-8 bg-orange-500 text-white px-10 py-4 rounded-2xl font-black shadow-xl shadow-orange-100 hover:bg-black transition-all"
//             >
//               Start Shopping
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useMemo } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, get } from "firebase/database";
import { auth, database as realtimeDb } from "../FirebaseConfig";
import { useLocation, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { 
  FaChevronDown, FaChevronUp, FaBox, FaTruck, FaClock, FaSearch, FaShoppingBag, FaCheckCircle
} from "react-icons/fa";

export default function OrdersPage() {
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("processing"); // "processing" or "placed"
  const [animationData, setAnimationData] = useState(null);
  const [expandedOrders, setExpandedOrders] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch("/assets/General/orderLoading.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        fetchUserOrders(currentUser.uid);
      } else {
        const path = new URLSearchParams(location.search).get("redirect") || "/orders";
        navigate(`/login?redirect=${path}`);
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const fetchUserOrders = async (uid) => {
    setLoading(true);
    try {
      const snapshot = await get(ref(realtimeDb, "orders"));
      if (snapshot.exists()) {
        const userOrders = Object.entries(snapshot.val())
          .filter(([_, order]) => order.userId === uid && order.paymentStatus !== "Failed")
          .map(([orderId, order]) => ({ orderId, ...order }))
          .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        setOrders(userOrders);
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  // UPDATED FILTER LOGIC: PROCESSING VS SUCCESSFULLY PLACED
  const filteredOrders = useMemo(() => {
    return orders.filter(order => {
      const matchesSearch = 
        order.orderId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.products.some(p => p.name.toLowerCase().includes(searchQuery.toLowerCase()));
      
      const status = order.orderStatus?.toLowerCase() || "";
      const isProcessing = status === 'processing' || status === 'pending';
      const isPlaced = status === 'delivered' || status === 'confirmed' || status === 'shipped' || status === 'placed';

      if (activeTab === "processing") return matchesSearch && isProcessing;
      if (activeTab === "placed") return matchesSearch && isPlaced;
      return matchesSearch;
    });
  }, [searchQuery, orders, activeTab]);

  if (loading) return (
    <div className="h-screen flex flex-col justify-center items-center bg-gray-50">
      <div className="w-64 md:w-80"><Lottie animationData={animationData} loop /></div>
      <p className="text-gray-500 font-medium animate-pulse mt-4">Fetching your honey orders...</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 mt-30  pb-10 px-4 md:px-10">
      <div className="max-w-6xl mx-auto">
        
        {/* HEADER & CONTROLS */}
        <div className="flex flex-col gap-3 mb-2">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
            <h1 className="text-3xl font-bold text-gray-900">My Orders</h1>
            
            <div className="relative w-full md:w-80">
              <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input 
                type="text" 
                placeholder="Search orders..."
                className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#f47d02]/20 focus:border-[#f47d02] outline-none transition-all shadow-sm text-sm"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* TOGGLE: PROCESSING vs SUCCESSFULLY PLACED */}
          <div className="flex bg-white p-1.5 rounded-2xl w-full md:w-max self-start border border-gray-200 shadow-sm">
            <button 
              onClick={() => setActiveTab("processing")}
              className={`flex-1 md:flex-none px-8 py-2.5 rounded-xl text-xs font-bold transition-all flex items-center gap-2 ${activeTab === "processing" ? 'bg-[#f47d02] text-white shadow-md' : 'text-gray-500 hover:bg-gray-50'}`}
            >
              <FaClock className={activeTab === "processing" ? "text-white" : "text-orange-400"} /> 
              Processing
            </button>
            <button 
              onClick={() => setActiveTab("placed")}
              className={`flex-1 md:flex-none px-8 py-2.5 rounded-xl text-xs font-bold transition-all flex items-center gap-2 ${activeTab === "placed" ? 'bg-green-600 text-white shadow-md' : 'text-gray-500 hover:bg-gray-50'}`}
            >
              <FaCheckCircle className={activeTab === "placed" ? "text-white" : "text-green-500"} /> 
               Placed
            </button>
          </div>
        </div>

        {filteredOrders.length > 0 ? (
          <div className="space-y-2">
            {filteredOrders.map((order) => {
              const isExpanded = expandedOrders[order.orderId];
              const status = order.orderStatus?.toLowerCase();
              // Green icon only if it's confirmed, delivered or shipped
              const isConfirmed = status === 'confirmed' || status === 'delivered' || status === 'shipped';

              return (
                <div key={order.orderId} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                  
                  {/* TOP STRIP */}
                  <div className="bg-gray-50/80 border-b border-gray-100 p-4 md:px-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-8 text-sm w-full md:w-auto overflow-x-auto pb-2 md:pb-0">
                      <div>
                        <p className="text-[10px] uppercase font-bold text-gray-400">Date</p>
                        <p className="font-semibold text-gray-700 whitespace-nowrap">{new Date(order.createdAt).toLocaleDateString()}</p>
                      </div>
                      <div className="border-l pl-8">
                        <p className="text-[10px] uppercase font-bold text-gray-400">Total Paid</p>
                        <p className="font-bold text-gray-900">₹{order.totalAmount}</p>
                      </div>
                      <div className="border-l pl-8 hidden md:block">
                        <p className="text-[10px] uppercase font-bold text-gray-400">Order ID</p>
                        <p className="font-mono text-xs text-gray-600">#{order.orderId}</p>
                      </div>
                    </div>

                    {status !== 'delivered' && (
                       <button
                         onClick={() => navigate(`/order?id=${order.orderId}`)}
                         className="bg-[#f47d02] text-white px-5 py-2.5 rounded-lg text-xs font-bold shadow-md shadow-orange-100 hover:brightness-110 transition-all flex items-center justify-center gap-2 w-full md:w-auto"
                       >
                         <FaTruck /> Track Order
                       </button>
                    )}
                  </div>

                  {/* CONTENT */}
                  <div className="p-6 md:px-8">
                    <div className="flex flex-col md:flex-row justify-between gap-6">
                      <div className="flex gap-4 items-start">
                        {/* ICON COLOR: GREEN IF CONFIRMED */}
                        <div className={`p-4 rounded-2xl border transition-all ${isConfirmed ? 'bg-green-50 border-green-200' : 'bg-orange-50 border-orange-100'}`}>
                          <FaBox className={isConfirmed ? "text-green-600" : "text-[#f47d02]"} size={24} />
                        </div>
                        <div>
                          <p className={`text-[10px] font-black uppercase tracking-widest mb-1 ${isConfirmed ? 'text-green-600' : 'text-orange-600'}`}>
                            {order.orderStatus}
                          </p>
                          <h3 className="text-lg font-bold text-gray-800 leading-tight">
                            {order.products[0]?.name}
                            {order.products.length > 1 && <span className="text-gray-400 font-medium text-sm"> + {order.products.length - 1} more items</span>}
                          </h3>
                        </div>
                      </div>

                      <button 
                        onClick={() => setExpandedOrders(prev => ({ ...prev, [order.orderId]: !prev[order.orderId] }))}
                        className="text-sm font-bold text-[#f47d02] flex items-center gap-1 hover:underline self-center"
                      >
                        {isExpanded ? "Hide Summary" : "View Summary"}
                        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                    </div>

                    {isExpanded && (
                      <div className="mt-6 pt-6 border-t border-gray-100 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 animate-in slide-in-from-top-2 duration-300">
                        {order.products.map((p, i) => (
                          <div key={i} className="flex gap-4 p-4 rounded-xl border border-gray-50 bg-gray-50/30">
                            <img src={p.thumbnail} className="w-16 h-16 rounded-lg object-cover border border-white" alt="" />
                            <div className="flex flex-col justify-center">
                              <p className="text-xs font-bold text-gray-800 line-clamp-1">{p.name}</p>
                              <p className="text-[10px] text-gray-400 font-bold uppercase mt-1">Quantity: {p.quantity}</p>
                              <p className="text-sm font-bold text-[#f47d02] mt-1">₹{p.actualPrice}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="bg-white rounded-3xl p-16 text-center shadow-sm border border-gray-200 flex flex-col items-center max-w-lg mx-auto mt-10">
            <div className="bg-orange-50 p-6 rounded-full mb-6 text-[#f47d02]">
              <FaShoppingBag size={40} />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">No {activeTab} orders</h2>
            <p className="text-gray-500 mt-2 text-sm px-4">
              {activeTab === "processing" 
                ? "All your jars are currently being harvested or shipped!" 
                : "Your successful order history is empty."}
            </p>
            <button 
              onClick={() => navigate('/shop')}
              className="mt-8 bg-[#f47d02] text-white px-10 py-3 rounded-xl font-bold shadow-lg shadow-orange-100"
            >
               Shop Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
}